module.exports = __webpack_public_path__ + "img/pic_333832_3.c2337a66.jpg";